import FieldForm from 'components/molecules/Form/Form';
import Item from 'components/molecules/Form/Field';
import useForm from 'components/molecules/Form/useForm';

const Form = FieldForm;
Form.Item = Item;
Form.useForm = useForm;

export { Item, useForm };

export default Form;
